module.exports = __webpack_public_path__ + "img/agentic-workflow.1103ea80.svg";